<!-- @let currentUser = currentUserSg(); -->
@let currentDate = currentDateSg();
@let selectedDate = pulseFeature.selectors.selectedDate.asSignal();

<div class="atn-summit-pulse-jumbotron">
  <div>
    <h2 class="atn-summit-pulse-jumbotron__title">Employee Pulse Dashboard</h2>
    <div class="atn-summit-pulse-jumbotron__subtitle">
      Updated on {{ currentDate }}
    </div>
  </div>
  <atn-ds-select-single
    [required]="true"
    [items]="dateOptions"
    [value]="selectedDate"
    (valueChange)="selectedDateChanged($event)"
  />
</div>
